import { AppLogo } from 'layouts';
import { Button, Col, Row, Title } from 'ui';

export const PageConferenceEnded = () => {
  const params = new URLSearchParams(window.location.search);
  const url = params.get('url');

  return (
    <Row align="middle" className="ended-conference-wrapper" justify="center">
      <Col className="ended-conference" lg={{ span: 12 }} md={{ span: 16 }} xs={{ span: 24 }}>
        <Col className="ended-conference__logo" span={24}>
          <AppLogo />
        </Col>
        <Col className="ended-conference__body" span={24}>
          <Title level={4} marginBottom>
            Your video conference has ended. Click on the button below to go back to the app.
          </Title>
          {url ? (
            <Button navigate={{ external: true, to: window.atob(url) }} size="large" type="primary">
              Back to app
            </Button>
          ) : null}
        </Col>
      </Col>
    </Row>
  );
};
